module.exports = __webpack_public_path__ + "img/CROWN RED.d1f034b.svg";